module.exports = __webpack_public_path__ + "media/images/pc/costumes/mv_shiromuku@2x-df838268c2c1ad58c5fe6d8ce38ce61d.webp";